export enum FormatTypes {
  CostandPriceFormat = 1,
  QuantityFormat = 2
}
